import { Injectable } from "@angular/core";
import { CurrentUser } from "../models/currentuser.models";
import { HttpClient } from "@angular/common/http";
import { TokenStorageService } from "./token-storage.service";
import { Observable } from "rxjs";
import { GlobalComponent } from "../../global-component";

const BASE_URL = GlobalComponent.BASE_API_URL;
@Injectable({ providedIn: 'root' })
export class IncentiveService {
    currentuser!: CurrentUser;
    constructor(private http: HttpClient, private tokenService: TokenStorageService) {
            this.currentuser = this.tokenService.getCurrentUser();
    }

    // Add Incentive Record
    addIncentiveData(postdata: any): Observable<any> {
            console.log("service postdata...", postdata)
            return this.http.post<any>(BASE_URL + 'incentives', postdata);
    }

    getIncentiveData(): Observable<any> {
        console.log("fetching incentive data");
        return this.http.get<any>(BASE_URL + 'incentives');
    }

    updateIncentiveStatus(recordguid: string, postdata: any): Observable<any> {
        return this.http.put<any>(BASE_URL + 'incentive/update/' + recordguid, { data: postdata });
    }

    getSingleIncentiveRecordData(recordguid: string): Observable<any> {
        return this.http.get<any>(BASE_URL + 'incentive/details/' + recordguid);
    }

    addIncentiveRejectedRecord(postdata: any): Observable<any> {
        return this.http.post<any>(BASE_URL + 'incentiverejecteds', {data : postdata});
    }

    getRejectedList(postdata: any): Observable<any> {
           const vendorguid = postdata.vendorguid;
           const activestate = true;
        // const performerguid = postdata.performerguid;
           const incentivejobguid = postdata.incentivejobguid;
           return this.http.get<any>(BASE_URL + 'incentiverejecteds?filters[activestate][$eq]=' + activestate + '&filters[vendorguid][$eq]=' + vendorguid + '&filters[incentivejobguid][$eq]=' + incentivejobguid);
    }

    getIncentiveMembersList(recordguid: string): Observable<any[]> {
            return this.http.get<any[]>(BASE_URL + 'incentive/memberlist/' + recordguid);
    }

    getIncentivesAttachments(recordguid: string): Observable<any[]> {
        console.log("fetching incentive attachments list");
        return this.http.get<any[]>(BASE_URL + 'incentiveattachments/attachments/' + recordguid);
    }

    cancelIncetiveProject(postdata: any): Observable<any> {
        return this.http.post<any>(BASE_URL + 'incentivecancels', { data: postdata });
    }

    editIncentiveData(postdata: any, recordId: number): Observable<any> {
        return this.http.put<any>(BASE_URL + GlobalComponent.incentivesGet + '/' + recordId, postdata);
    }

    releaserecord(jobguid: string, postdata: any) {
        return this.http.put<any>(BASE_URL + 'incentive/releaserecord/' + jobguid, { data: postdata });
    }
}